module.exports = __webpack_public_path__ + "img/card-dress-ext.52f3144b.png";